<!-- my-table.component.html -->
<h4 *ngIf="hasHeader">{{ tableHeader }}</h4>
<!-- Search and Add Role section -->
<div
  class="d-flex justify-content-center justify-content-xl-between align-items-center gap-3 flex-wrap flex-lg-row-reverse"
  *ngIf="hasSearchInp">
  <!-- Buttons Action -->
  <div id="buttons-actions" class="d-flex align-items-center flex-wrap gap-3">
    @if (showToggleFillter) {
    <div class="toggle d-flex align-items-center gap-1">
      <span>{{ toggleFillterText }}</span>
      <p-toggleButton [onLabel]="toggleFilterTextOn | translate" [offLabel]="toggleFilterTextOff | translate"
        [onIcon]="'pi pi-filter'" [offIcon]="'pi pi-filter-slash'" [(ngModel)]="isFilterActive"
        (onChange)="onToggleFilterChange($event)" class="p-button-outlined p-button-main text-nowrap">
      </p-toggleButton>
    </div>
    }

    <div *ngIf="showOtherActionBtn">
      <button class="btn btn-outline-main text-nowrap" (click)="onOtherActionButtonClick()">
        <!-- <i class="pi pi-plus"></i> -->
        <span>{{ otherActionBtnText }}</span>
      </button>
    </div>
    <div *ngIf="showFilterBtn">
      <button class="btn btn-outline-main" (click)="openSidebar()">
        <span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.33336 16C9.18911 16 9.04876 15.9532 8.93336 15.8667L6.26669 13.8667C6.1839 13.8046 6.11669 13.724 6.07041 13.6315C6.02412 13.5389 6.00003 13.4368 6.00003 13.3333V9.58667L1.32269 4.32467C0.990508 3.94992 0.773614 3.48721 0.698081 2.99216C0.622548 2.4971 0.69159 1.99077 0.89691 1.53401C1.10223 1.07725 1.43509 0.689506 1.85548 0.417377C2.27587 0.145249 2.76591 0.000316279 3.26669 0L12.7334 0C13.2341 0.000587367 13.724 0.14576 14.1442 0.418071C14.5645 0.690383 14.8971 1.07825 15.1022 1.53506C15.3073 1.99187 15.3761 2.49818 15.3004 2.99316C15.2247 3.48815 15.0076 3.95073 14.6754 4.32533L10 9.58667V15.3333C10 15.5101 9.92979 15.6797 9.80476 15.8047C9.67974 15.9298 9.51017 16 9.33336 16ZM7.33336 13L8.66669 14V9.33333C8.66683 9.1701 8.72684 9.0126 8.83536 8.89067L13.6807 3.43933C13.8423 3.25672 13.9477 3.03136 13.9843 2.7903C14.021 2.54924 13.9872 2.30274 13.8872 2.08037C13.7872 1.85801 13.6251 1.66924 13.4204 1.53673C13.2158 1.40421 12.9772 1.33359 12.7334 1.33333H3.26669C3.02299 1.3337 2.78458 1.40436 2.58003 1.53684C2.37549 1.66932 2.2135 1.858 2.1135 2.08023C2.0135 2.30247 1.97973 2.54884 2.01625 2.78979C2.05276 3.03074 2.15801 3.25604 2.31936 3.43867L7.16536 8.89067C7.27364 9.0127 7.33341 9.17019 7.33336 9.33333V13Z"
              fill="#012969" />
          </svg>
          Filters
        </span>
      </button>
    </div>
    <div *ngIf="showBtn">
      <button class="btn btn-solid-main text-nowrap" (click)="onButtonClick()">
        <i class="pi pi-plus"></i>
        <span>{{ buttonText }}</span>
      </button>
    </div>
    <div *ngIf="!showBtn">
      <span></span>
    </div>
  </div>

  <!-- Search input field -->
  <div class="search-input" *ngIf="hasSearchInp">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input type="text" pInputText [placeholder]="('GENERAL.SEARCH' | translate)" [(ngModel)]="searchTerm"
        (input)="onSearch()" />
    </p-iconField>
  </div>
</div>

<!-- Desktop Table View -->
<!-- Table displaying filtered items -->
<!-- @if(items.data?.length! > 0 && !isMobile){ -->
<p-table [value]="this.items.data ?? []" responsiveLayout="stack">
  <!-- Header template -->
  <ng-template pTemplate="header">
    <tr>
      <!-- Table headers based on the provided headers -->
      <ng-container *ngFor="let item of items.headers">
        <!-- Conditional sorting column header -->
        @if(enableSorting){
        <th pSortableColumn="item.lable">{{ item | translate }} <p-sortIcon field="item.lable"></p-sortIcon></th>
        } @else {
        <!-- Non-sorting column header -->
        <th>{{ item | translate }}</th>
        }
      </ng-container>
    </tr>
  </ng-template>

  <!-- Body content template -->
  <ng-template pTemplate="body" let-rowData>
    <!-- Default table row -->
    @if(isLoading){
    <!-- Show skeleton row while loading -->
    <tr>
      <td *ngFor="let key of items.dataKeys">
        <p-skeleton width="100%"></p-skeleton>
      </td>
    </tr>
    } @else{
    <!-- Regular data row -->
    <tr *ngIf="!customTemplate">
      <ng-container *ngFor="let key of items.dataKeys">
        <td>{{ rowData[key] || '-' }}</td>
      </ng-container>
    </tr>
    <ng-container *ngIf="customTemplate">
      <ng-container *ngTemplateOutlet="bodyTemplate; context: { $implicit: rowData }"></ng-container>
    </ng-container>
    }
  </ng-template>
</p-table>
<!-- } -->

<!-- Card view for mobile/tablet -->
<!-- @if(items.data?.length! > 0 && isMobile){
<div class="card-list">
  @for(row of items.data; track row.id){
  <div class="single-card">
    @for(key of items.dataKeys; track $index){
    <div class="card-row">
      <span class="card-label">{{ items.headers[$index] | translate }}</span>
      @if(key === 'isActive'){
      @if(formatValue(key, getNestedValue(row, key))){
      <span class="badge badge-success">
        {{"GENERAL.ACTIVE" | translate}}
      </span>
      } @else {
      <span class="badge badge-danger">
        {{"GENERAL.INACTIVE" | translate}}
      </span>
      }
      } @else if(key === 'element.status'){
      @if(formatValue(key, getNestedValue(row, key)) === 'Fulfilled'){
      <span class="badge badge-success">{{"GENERAL.FULFILLED" | translate}}</span>
      } @else if(formatValue(key, getNestedValue(row, key)) === 'Pending'){
      <span class="badge badge-warning">{{"GENERAL.PENDING" | translate}}</span>
      } @else if(formatValue(key, getNestedValue(row, key)) === 'Processing'){
      <span class="badge badge-primary">{{"GENERAL.PROCESSING" | translate}}</span>
      } @else {
      <span class="badge badge-secondary">{{ formatValue(key, getNestedValue(row, key)) || '-' }}</span>
      }
      } @else if(key === 'phoneNumber'){
      <ng-container *ngIf="getNestedValue(row, key) as phone">
        <app-phone-number [phoneNumber]="phone"></app-phone-number>
      </ng-container>
      } @else if(key === 'Actions' || key === 'actions'){
      <app-table-actions [entity]="row" [supportedActions]="supportedActions"></app-table-actions>
      } @else if(key === 'Action'){
      @if(actionsTemplate){
      <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
      }
      }
      @else {
      <span class="card-value">{{ formatValue(key, getNestedValue(row, key)) || '-' }}</span>
      }
    </div>
    }
  </div>
  }
</div>
} -->

<!-- Pagination controls -->
<div class="pagination-container d-flex justify-content-between align-items-center"
  *ngIf="enablePagination && items?.data?.length! > 0">
  <!-- Pagination component -->
  <ngb-pagination [collectionSize]="totalRecords" [(page)]="page" [maxSize]="3" [pageSize]="size" [boundaryLinks]="true"
    (pageChange)="onPageChange($event)" />
  <!-- Page size selection and display -->
  <div class="shown-number">
    <span>{{"GENERAL.PAGE" | translate}}</span>
    <p-dropdown [options]="pageSizesPaginations" [(ngModel)]="pageSize" (onChange)="onPageSizeChange($event)" />
    <span>{{"GENERAL.OF" | translate}} {{ totalRecords }}</span>
  </div>
</div>

<app-no-data-message *ngIf="items?.data?.length == 0"
  [message]="HandelRenderingDataMessage | translate"></app-no-data-message>


<app-filter [visible]="sidebarVisible" (visibleChange)="onSidebarVisibleChange($event)"
  (applyFilter)="onApplyFilter($event)" (clearFilter)="onClearFilter()" [filterOptions]="filterOptions">
</app-filter>